/**
 * <s-image-guard> — discourages saving photos.
 *
 * Blocks the context menu (right-click, and long-press on Android) and dragging
 * for every image on the page. iOS long-press is handled in CSS on <body>
 * (-webkit-touch-callout: none on images).
 *
 * Required markup: one <s-image-guard hidden></s-image-guard> anywhere in the layout.
 */
class SImageGuard extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal, capture: true };
    document.addEventListener('contextmenu', this.#block, opts);
    document.addEventListener('dragstart', this.#block, opts);
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #block = (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (target.closest('img, picture, video, [data-image-shield]')) {
      event.preventDefault();
    }
  };
}

if (!customElements.get('s-image-guard')) {
  customElements.define('s-image-guard', SImageGuard);
}
